import {filterObject} from '@benchling/js-utils';

import BenchlingConfig from 'BenchlingConfig';
import {Equation} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/FlatEquationSolver';
import {StoichiometryVariable} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/StoichiometryEquations';
import {StoichiometryCalculationVariableValues} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/StoichiometrySolver';
import PreciseDecimal from 'util/precise-decimal/PreciseDecimal';
import {findMinSigFigs, applySigFigs} from 'util/precise-decimal/SignificantFigures';

/** All the variables that should be considered for calculating the minimum number of Sig Figs.
 *
 * The rest are considered to have infinite significant figures. */
const SIG_FIG_VARIABLES = new Set<StoichiometryVariable>([
  StoichiometryVariable.LIMITING_REACTANT_MOLS,
  StoichiometryVariable.FORMULA_WEIGHT,
  StoichiometryVariable.MOLS,
  StoichiometryVariable.MASS,
  StoichiometryVariable.VOLUME,
  StoichiometryVariable.DENSITY,
  StoichiometryVariable.MOLARITY,
]);

export function applyStoichiometrySigFigs(
  preciseDecimal: PreciseDecimal,
  variableValues: StoichiometryCalculationVariableValues,
  equation: Equation<StoichiometryVariable, PreciseDecimal>
): PreciseDecimal {
  const variablesForSigFigs = filterObject(
    variableValues,
    (value, variable) => value != null && equation.deps.includes(variable) && SIG_FIG_VARIABLES.has(variable)
  );
  const minSigFigs = findMinSigFigs(...Object.values(variablesForSigFigs));
  if (!minSigFigs) {
    return preciseDecimal;
  }
  return applySigFigs(preciseDecimal, minSigFigs, BenchlingConfig.SCHEMAS_DECIMAL_ROUNDING_STRATEGY);
}
